import { Injectable } from '@angular/core';
import {
  DEFAULT_OPACITY,
  LayerSettingsState2D,
} from '../../../cross-team-shared/state/layer-settings-state-2d';
import { AbstractLayerSettingsService } from '../../../cross-team-shared/toolbars/layer-settings/abstract-layer-settings.service';
import { VideoContentStore } from '../state/video-content-store';

@Injectable()
export class VideoLayerSettingsService extends AbstractLayerSettingsService<
  VideoContentStore,
  LayerSettingsState2D
> {
  protected override getDefaultSettings() {
    return new LayerSettingsState2D(DEFAULT_OPACITY);
  }
}
